<div
  class="recording-segments"
  [class.recording-segments--busy]="busy"
  [class.recording-segments--media-not-ready]="mediaNotReady()"
  [attr.aria-busy]="busy"
>
  <div class="recording-segments__progress" role="status">
    @if (busy) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <span class="cdk-visually-hidden">
        {{ 'TRANS__SEARCH__LOADING_INFO' | translate }}
      </span>
    }
  </div>

  <div class="recording-segments__selected-media">
      <span class="">
        {{ 'TRANS__FIELD__RECORDING_SEGMENT__PARENT' | translate }}
      </span>

    <button
      mat-stroked-button
      [matMenuTriggerFor]="audioMenu"
      [disabled]="busy"
      style="width: fit-content"
    >
      <mat-icon class="material-symbols-outlined">
        @if (selectedMediaElement()?.mediaObject.object_type === 'Video') {
          video_file
        } @else {
          audio_file
        }
      </mat-icon>
      {{ selectedMediaElement()?.mediaItem.$$mediaName }}
      <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
    </button>

    <mat-menu #audioMenu="matMenu">
      @for (media of mediaElements; track media.mediaObject.artifact_id) {
        <button
          mat-menu-item
          [disabled]="busy || media.mediaObject.artifact_id === selectedMediaElement()?.mediaObject.artifact_id"
          [class.active]="media.mediaObject.artifact_id === selectedMediaElement()?.mediaObject.artifact_id"
          (click)="selectMediaElement(media)"
        >
          <mat-icon class="material-symbols-outlined">
            @if (media.mediaObject.object_type === 'Video') {
              video_file
            } @else {
              audio_file
            }
          </mat-icon>
          {{ media.mediaItem.$$mediaName }}
        </button>
      }
    </mat-menu>
  </div>

  @if (mediaNotReady()) {
    <div class="recording-segments__media-not-ready" role="status">
      <mat-icon class="material-symbols-outlined">hourglass_empty</mat-icon>
      <span>{{ 'TRANS__ACTIVE_MEDIA__MEDIA_NOT_READY' | translate }}</span>
    </div>
  } @else {
    <app-audio-waveform-player
      class="recording-segments__player"
      [controlsOnTop]="true"
      [enableRegionEdit]="true"
      [showVideo]="selectedMediaElement()?.mediaObject?.object_type === 'Video'"
      [disabled]="busy"
      [playbackUrl]="mediaPlaybackUrl()"
      [regions]="playerSegmentRegions()"
      [draftRegion]="draftRegion()"
      (playing)="onPlayerPlaying($event)"
      (cursorMoved)="onPlayerCursorMoved($event)"
      (currentRegion)="onPlayerRegionAtCursor($event)"
      (regionUpdated)="onPlayerRegionUpdated($event)"
      (loadFailed)="onPlayerLoadFailed($event)"
    />
  }

  <section class="recording-segments__segment-form">
    <h2>{{ 'TRANS__CREATE_NEW__RECORDING_SEGMENT_HEADLINE' | translate }}</h2>

    <p>{{ 'TRANS__CREATE_NEW__RECORDING_SEGMENT_TEXT' | translate }}</p>

    <app-recording-segment-form
      [(segment)]="draftSegment"
      [submitting]="isSubmittingSegment()"
      [disabled]="segmentFormDisabled"
      (submitted)="onSegmentFormSubmitted($event)"
      (cleared)="onSegmentFormCleared()"
    />
  </section>

  <section class="recording-segments__segment-list">
    <app-recording-segment-table
      [segments]="recordingSegments()"
      [activeSegment]="activeSegment()"
      [isPlaying]="isPlaying()"
      [disabled]="busy || mediaNotReady()"
      (segmentPlayClicked)="onSegmentPlayClicked($event)"
    />
  </section>
</div>
